import { Action } from "..";
import { IngestState, MappingState } from "./ingestSlice";

export const toggleHeader = (state: IngestState) => {
    if(state.mapping == null) {
        return state;
    }
    state.mapping.hasHeader = !state.mapping.hasHeader;
    return state;
}

export const cancellingMapping = (state:IngestState) => {
    if(state.mapping == null) {
        return state;
    }
    state.mapping.cancelling = true;
    return state;
}

export const discardMapping = (state: IngestState) => {
    state.mapping = undefined;
    return state;
}

export const updateMapping = (state:IngestState, action:Action<{position:number, col:string}>) => {
    if(state.mapping == null) return state;
    const {position,col} = action.payload;
    if(state.mapping.mapping != null) {
        state.mapping.mapping[position] = col;
    }
    return state;
}

export const clearMapping = (state:IngestState, action:Action<{position:number}>) => {
    if(state.mapping == null) return state;
    if(state.mapping.mapping != null) { 
        delete state.mapping.mapping[action.payload.position];
    }
    return state;
}